module.exports = __webpack_public_path__ + "static/media/logo-danal@2x.99f62a6f.png";